// @flow
import React from 'react';
import { injectIntl } from 'react-intl';

import './WhereIsMyVin.scss';

const cn = 'where-is-my-vin';

type Props = {
  intl: Object
};

function WhereIsMyVin({ intl }: Props) {
  return (
    <div className={cn} tabIndex={0} aria-modal={true}>
      <div className="text-center">
        {intl.formatMessage({
          id: 'c8.recall.search.page.vin.modal.subtitle'
        })}
      </div>
      <div className={`${cn}__vehicle-wrap`}>
        <div
          className={`${cn}__vehicle-img-container`}
          aria-label={intl.formatMessage({
            id: 'c8.aria.where.to.find.vin.number',
            defaultMessage: 'Where to find vin number'
          })}
        >
          <img
            className={`${cn}__vehicle-img`}
            src={require('./vehicle-img.png')}
            alt={'vehicle-img'}
          />
          <div className={`${cn}__find-vin-top`}>
            <div className={`${cn}__find-vin-here`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.vin.modal.bubble.find.vin.here'
              })}
            </div>
            <div className={`${cn}__upper-line`} />
            <div className={`${cn}__upper-dot`} />
          </div>
          <div className={`${cn}__find-vin-bottom`}>
            <div className={`${cn}__bottom-line`} />
            <div className={`${cn}__bottom-dot`} />
            <div className={`${cn}__or-here`}>
              {intl.formatMessage({
                id: 'c8.recall.search.page.vin.modal.bubble.or.here'
              })}
            </div>
          </div>
        </div>
      </div>
      <ul>
        <li>
          {intl.formatMessage({
            id: 'c8.recall.search.page.vin.modal.list.driver.dashboard'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'c8.recall.search.page.vin.modal.list.door.panel'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'c8.recall.search.page.vin.modal.list.insurance.card'
          })}
        </li>
        <li>
          {intl.formatMessage({
            id: 'c8.recall.search.page.vin.modal.list.registration.card'
          })}
        </li>
      </ul>
      <div className="text-center">
        {intl.formatMessage({
          id: 'c8.recall.search.page.vin.modal.label.example'
        })}
      </div>
    </div>
  );
}

WhereIsMyVin.block = 'where-is-my-vin';

export default injectIntl(WhereIsMyVin);



// WEBPACK FOOTER //
// ./src/components/molecules/WhereIsMyVin/WhereIsMyVin.js